import styled from 'styled-components';
import theme from './theme';
const { colors } = theme;

const Nav = styled.nav`
  width: 100%;
  color: ${colors.white};
`;

export default Nav;
